<template>
  <div>
    <define-password-form />
  </div>
</template>

<script>
import definePasswordForm from "../components/login/DefinePasswordForm";

export default {
  components: {
    definePasswordForm
  }
};
</script>
